function isTouchDevice() {
    return 'ontouchstart' in document.documentElement;
}

const html = document.querySelector('html');
if (isTouchDevice()) {
    html.classList.add('-is-touch-device');
} else {
    html.classList.add('-not-touch-device');
}
